export const GET_CHAT_SETTINGS_QUERY_KEY = 'chatSettings'
